var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#000000' : _b, props = __rest(_a, ["fill"]);
    return (_jsx("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M8.00007 0C3.58127 0 0 3.58127 0 8C0 12.4187 3.58127 16 8.00007 16C12.4187 16 16 12.4187 16 8C16 3.58127 12.4187 0 8.00007 0ZM10.699 9.56763C11.0115 9.88013 11.0115 10.3864 10.699 10.6989C10.3863 11.0116 9.88013 11.0113 9.5677 10.6989L8 9.1312L6.4323 10.6989C6.1196 11.0116 5.61347 11.0113 5.30103 10.6989C4.98853 10.3864 4.98853 9.88013 5.30103 9.56763L6.86873 7.99993L5.30103 6.4323C4.98853 6.1198 4.98853 5.61353 5.30103 5.30103C5.61353 4.98853 6.1198 4.98853 6.4323 5.30103L8 6.86873L9.5677 5.30103C9.8802 4.98853 10.3865 4.98853 10.699 5.30103C11.0115 5.61353 11.0115 6.1198 10.699 6.4323L9.13127 7.99993L10.699 9.56763Z", fill: fill }) })));
});
